import React from 'react';

// const ServiceCard = ({ icon, title, description }) => {
//     return (
//         <div className="service-card">
//             <div className="service-icon">{icon}</div>
//             <h3>{title}</h3>
//             <p>{description}</p>
//         </div>
//     );
// };


// export default ServiceCard;

const ServiceCard = ({ icon, title, description }) => {
  return (
    <div className="service-card">
      <div className="service-icon-container">
        {typeof icon === 'string' && (icon.startsWith('/') || icon.startsWith('http')) ? (
          // SHOW IMAGE for paths like '/images/or_01.jpeg'
          <img 
            src={icon} 
            alt={`${title} icon`}
            className="service-icon"
            style={{ width: '220px', height: '100px', objectFit: 'cover', borderRadius: '12px' }}
          />
        ) : (
          // SHOW EMOJI for '🦷', '🪥', etc.
          <span className="service-icon" style={{ fontSize: '2.5rem' }}>
            {icon}
          </span>
        )}
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default ServiceCard;
